<template>
    <div>
        <router-view></router-view>
    </div>
</template>
  
<script>
export default {
    name: 'productPage',
    data() {
        return {

        }
    },
    methods: {

    },

}

</script>
<style scoped></style>